import ReactTable from "../Components/ReactTable";
import React, {useMemo} from "react";
import {getNicelyFormattedNumber} from "../../utils/formatUtil";
import Chart from "react-apexcharts";

function parseDollar(val) {
    return parseFloat(val.replace('$', ''));
}

const BucketPrice = ({header, fileContents, filePath}) => {

    const data = fileContents.subdirs;

    const series = data.map(item => parseFloat(item.annualCost.replace("$", "")));
    const labels = data.map(item => item.path);

    const chartSeries = useMemo(() => series, [series]);

    const customColumns = [
        {header: "Path", accessorKey: "path", size: 600, footer: () => <span>Totals</span>},
        {
            header: "Size",
            accessorKey: "size",
            footer: (row) => {
                const displayedRowsSum = row.table.getFilteredRowModel().rows
                    .reduce((sum, item) => {

                        const sizeNumeric = parseFloat(item.original.size.replace(/[^0-9.]+/g, ''))
                        return sum + (isNaN(sizeNumeric) ? 0 : sizeNumeric);
                    }, 0)
                return <span>{getNicelyFormattedNumber(displayedRowsSum, 2)} GB</span>;
            },
            sortingFn: (rowA, rowB, col) => parseInt(rowA.getValue(col)) - parseInt(rowB.getValue(col))
        },
        {
            header: "Annual Cost",
            accessorKey: "annualCost",
            footer: (row) => {
                const displayedRowsSum = row.table.getFilteredRowModel().rows
                    .reduce((sum, item) => {
                        const annualCostNumeric = parseFloat(item.original.annualCost.replace(/[^0-9.]+/g, ''))
                        return sum + (isNaN(annualCostNumeric) ? 0 : annualCostNumeric);
                    }, 0)
                return <span>${getNicelyFormattedNumber(displayedRowsSum, 2)}</span>;
            },
            sortingFn: (rowA, rowB, col) => parseDollar(rowA.getValue(col)) - parseDollar(rowB.getValue(col))
        }
    ];

    const options = {
        chart: {
            type: 'donut',
            redrawOnParentResize: true
        },
        labels
    }

    return (
        <div>
            <h2 id={filePath}>{header}</h2>
            <div className={'bucket-price-container'}>
                <div className={'bucket-price-selections'}>
                    <div className={"bucket-price-column"}>
                        <div className={'bucket-price-selections-table'}>
                            <ReactTable
                                data={data}
                                filterable
                                columns={customColumns}
                                initialState={{sorting: [{id: 'annualCost', desc: true}], pagination: {pageSize: 10}}}
                            />
                        </div>
                    </div>
                </div>
                <div className={'bucket-price-selections'}>
                    <div className={"bucket-price-column"}>
                        <div className={'bucket-price-selections-chart'}>
                            <Chart
                                options={options}
                                series={chartSeries}
                                type={'donut'}
                                width={800}
                                height={800}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BucketPrice;